"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var BetaHeader = function BetaHeader(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "control-header--beta"
  }, children);
};

var _default = BetaHeader;
exports.default = _default;